import React from 'react';
import PropTypes from 'prop-types';

import { useRouter } from 'next/router';
import { compact } from 'lodash';
import { Router } from '../../../src/i18n';
import route, { festivalPaths } from '../../../constants/routes';
import { getQueryParamFromPath } from '../../../utils/common';
import { TP } from '../../../constants/consts';
import FbTabs from '../../../components/FbTabs';
import { getFestivalRoute } from '../utils';
import EditStubPageHeader from '../../../components/EditComponents/EditStubPageHeader';
import EditFestival from './EditFestival';
import EditFestivalSeasons from './EditFestivalSeasons';

export const editFestivalTabValues = {
  edit: 'edit',
  seasons: 'seasons',
};

const editTabs = [
  { name: `${TP}.FN_FESTIVAL_EDIT`, value: editFestivalTabValues.edit },
  { name: `${TP}.m_SEASON`, value: editFestivalTabValues.seasons },
];

const FestivalEdit = ({ festival }) => {
  const NextRouter = useRouter();
  const [tabValue, setTabValue] = React.useState(
    getQueryParamFromPath(NextRouter.asPath, 'tab') || editFestivalTabValues.edit,
  );

  const setSelectedTab = value => {
    Router.push(festivalPaths.edit, `${getFestivalRoute(festival)}/edit?tab=${value}`, {
      shallow: true,
    });
    setTabValue(value);
  };

  return (
    <>
      <EditStubPageHeader
        entity={festival}
        backToLinkProps={{ href: route.FESTIVALS, as: route.FESTIVALS }}
        backToLinkText={`${TP}.BACK_TO_FESTIVALS`}
        entityInfo={compact([festival?.country?.name, festival?.city?.name]).join(', ')}
        viewModeLinkProps={{ href: festivalPaths.view, as: getFestivalRoute(festival) }}
      />
      <FbTabs tabs={editTabs} initialTabValue={editFestivalTabValues.edit} value={tabValue} onChange={setSelectedTab} />
      <section style={{ marginTop: 30 }}>
        {tabValue === editFestivalTabValues.edit && <EditFestival festival={festival} />}
        {tabValue === editFestivalTabValues.seasons && <EditFestivalSeasons />}
      </section>
    </>
  );
};

FestivalEdit.propTypes = {
  festival: PropTypes.object,
};

export default FestivalEdit;
